// Centralized image imports for projects
// This file organizes all project images to reduce duplication
// Last reviewed: January 2026

// Professional Projects - Card Images
import canalsmartCard from "@/images/Pro/Canalsmart/one.png";
import cesantaCard from "@/images/Pro/Cesanta/one.png";
import trainlineAdminCard from "@/images/Pro/JR_Admin/four.png";
import trainlineUserCard from "@/images/Pro/JR_User/four.png";
import uiLibraryCard from "@/images/Pro/UI_Library/four.png";
import jrProjectCard from "@/images/Pro/JRProject/one.png";
import svensonCard from "@/images/Pro/Svenson/one.png";
import svensonUserCard from "@/images/Pro/SvensonUser/one.png";
import kammekoCard from "@/images/Pro/Kammeko/one.png";
import octacleCard from "@/images/Pro/Octacle/one.png";
import nurseryCard from "@/images/Pro/Nursery/one.png";
import budgetCalcCard from "@/images/Pro/BudgetCalculator/one.png";
import revaCard from "@/images/Pro/Reva/one.png";

// Professional Projects - Detail Images
import canalsmart1 from "@/images/Pro/Canalsmart/one.png";
import canalsmart2 from "@/images/Pro/Canalsmart/two.png";
import canalsmart3 from "@/images/Pro/Canalsmart/three.png";
import canalsmart4 from "@/images/Pro/Canalsmart/Four.png";
import cesanta1 from "@/images/Pro/Cesanta/one.png";
import cesanta2 from "@/images/Pro/Cesanta/two.png";
import cesanta3 from "@/images/Pro/Cesanta/three.png";
import trainlineAdmin1 from "@/images/Pro/JR_Admin/four.png";
import trainlineAdmin2 from "@/images/Pro/JR_Admin/two.png";
import trainlineAdmin3 from "@/images/Pro/JR_Admin/three.png";
import trainlineUser1 from "@/images/Pro/JR_User/four.png";
import trainlineUser2 from "@/images/Pro/JR_User/two.png";
import trainlineUser3 from "@/images/Pro/JR_User/three.png";
import uiLibrary1 from "@/images/Pro/UI_Library/one.png";
import uiLibrary2 from "@/images/Pro/UI_Library/two.png";
import uiLibrary3 from "@/images/Pro/UI_Library/three.png";
import jrproject1 from "@/images/Pro/JRProject/one.png";
import jrproject2 from "@/images/Pro/JRProject/two.png";
import jrproject3 from "@/images/Pro/JRProject/three.png";
import svenson1 from "@/images/Pro/Svenson/one.png";
import svenson2 from "@/images/Pro/Svenson/two.png";
import svenson3 from "@/images/Pro/Svenson/three.png";
import svensonUser1 from "@/images/Pro/SvensonUser/one.png";
import svensonUser2 from "@/images/Pro/SvensonUser/two.png";
import svensonUser3 from "@/images/Pro/SvensonUser/three.png";
import kammeko1 from "@/images/Pro/Kammeko/one.png";
import kammeko2 from "@/images/Pro/Kammeko/two.png";
import kammeko3 from "@/images/Pro/Kammeko/three.png";
import octacle2 from "@/images/Pro/Octacle/two.png";
import octacle3 from "@/images/Pro/Octacle/three.png";
import octacle4 from "@/images/Pro/Octacle/four.png";
import nursery1 from "@/images/Pro/Nursery/one.png";
import nursery2 from "@/images/Pro/Nursery/two.png";
import nursery3 from "@/images/Pro/Nursery/three.png";
import budget2 from "@/images/Pro/BudgetCalculator/two.png";
import budget3 from "@/images/Pro/BudgetCalculator/three.png";
import budget4 from "@/images/Pro/BudgetCalculator/four.png";
import linkzapCard from "@/images/Pro/Linkzap/one.png";
import linkzap1 from "@/images/Pro/Linkzap/one.png";
import linkzap2 from "@/images/Pro/Linkzap/two.png";
import linkzap3 from "@/images/Pro/Linkzap/three.png";
import linkzap4 from "@/images/Pro/Linkzap/four.png";
import reva2 from "@/images/Pro/Reva/two.png";
import reva3 from "@/images/Pro/Reva/three.png";
import reva4 from "@/images/Pro/Reva/four.png";
import lotteryCard from "@/images/Pro/LotteryTracker/one.png";
import lottery1 from "@/images/Pro/LotteryTracker/one.png";
import lottery2 from "@/images/Pro/LotteryTracker/two.png";
import lottery3 from "@/images/Pro/LotteryTracker/three.png";

// Personal Projects - Card Images
import spotifyCard from "@/images/Personal/SpotifyClone/one.png";
import disneyCard from "@/images/Personal/DisneyClone/one.png";
import crudCard from "@/images/Personal/CRUD-store/one.png";
import reduxFilmCard from "@/images/Personal/Redux-film/one.png";
import teslaCard from "@/images/Personal/TeslaClone/one.png";
import zoomCard from "@/images/Personal/zoomClone/one.png";
import whatsappCard from "@/images/Personal/WhatsappClone/wa1.png";
import movieCard from "@/images/Personal/MovieList/one.png";
import artCard from "@/images/Personal/Artistible/one.png";
import travelCard from "@/images/Personal/TravelAdvisor/one.png";
import doggyCard from "@/images/Personal/DoggyTeam/one.png";
import streakyCard from "@/images/Personal/Streaky/one.png";
import nsunsCard from "@/images/Personal/Nsuns/one.png";

// Personal Projects - Detail Images
import dc1 from "@/images/Personal/DisneyClone/one.png";
import dc2 from "@/images/Personal/DisneyClone/two.png";
import dc3 from "@/images/Personal/DisneyClone/three.png";
import sp1 from "@/images/Personal/SpotifyClone/one.png";
import sp2 from "@/images/Personal/SpotifyClone/two.png";
import sp3 from "@/images/Personal/SpotifyClone/three.png";
import ar1 from "@/images/Personal/Artistible/one.png";
import ar2 from "@/images/Personal/Artistible/two.png";
import ar3 from "@/images/Personal/Artistible/three.png";
import tc1 from "@/images/Personal/TeslaClone/one.png";
import tc2 from "@/images/Personal/TeslaClone/two.png";
import tc3 from "@/images/Personal/TeslaClone/three.png";
import dt1 from "@/images/Personal/DoggyTeam/one.png";
import dt2 from "@/images/Personal/DoggyTeam/two.png";
import dt3 from "@/images/Personal/DoggyTeam/three.png";
import ml1 from "@/images/Personal/MovieList/one.png";
import ml2 from "@/images/Personal/MovieList/two.png";
import ml3 from "@/images/Personal/MovieList/three.png";
import wa1 from "@/images/Personal/WhatsappClone/wa1.png";
import wa2 from "@/images/Personal/WhatsappClone/wa2.png";
import wa3 from "@/images/Personal/WhatsappClone/wa3.png";
import ta1 from "@/images/Personal/TravelAdvisor/one.png";
import ta2 from "@/images/Personal/TravelAdvisor/two.png";
import ta3 from "@/images/Personal/TravelAdvisor/three.png";
import rf1 from "@/images/Personal/Redux-film/one.png";
import rf2 from "@/images/Personal/Redux-film/two.png";
import rf3 from "@/images/Personal/Redux-film/three.png";
import crud1 from "@/images/Personal/CRUD-store/one.png";
import crud2 from "@/images/Personal/CRUD-store/two.png";
import crud3 from "@/images/Personal/CRUD-store/three.png";
import zc1 from "@/images/Personal/zoomClone/one.png";
import zc2 from "@/images/Personal/zoomClone/two.png";
import zc3 from "@/images/Personal/zoomClone/three.png";
import streaky1 from "@/images/Personal/Streaky/one.png";
import streaky2 from "@/images/Personal/Streaky/two.png";
import streaky3 from "@/images/Personal/Streaky/three.png";
import nsuns1 from "@/images/Personal/Nsuns/two.png";
import nsuns2 from "@/images/Personal/Nsuns/three.png";
import nsuns3 from "@/images/Personal/Nsuns/six.png";
import playwrightCertificate from "@/images/playwrite_automation.png";

// Mini Projects
import comingSoon from "@/images/comingsoon.png";
import rps from "@/images/MiniProjects/Rock-paper-scissors.png";
import tm1 from "@/images/Personal/TinyMe/one.png";
import theme from "@/images/MiniProjects/theme_toggle.png";
import counter from "@/images/MiniProjects/counter.png";
import grocery from "@/images/MiniProjects/grocery.png";
import blackjack from "@/images/MiniProjects/blackjack.png";
import calculator from "@/images/MiniProjects/calculator.png";
import snake from "@/images/MiniProjects/snake.png";
import notes from "@/images/MiniProjects/notes.png";
import quiz from "@/images/MiniProjects/quiz.png";
import task from "@/images/MiniProjects/task.png";
import weather from "@/images/MiniProjects/weather.png";

// Export organized image objects
export const ProjectImages = {
  pro: {
    canalsmart: {
      card: canalsmartCard,
      detail: [canalsmart2, canalsmart3, canalsmart4],
    },
    cesanta: { card: cesantaCard, detail: [cesanta1, cesanta2, cesanta3] },
    trainlineAdmin: {
      card: trainlineAdminCard,
      detail: [trainlineAdmin1, trainlineAdmin2, trainlineAdmin3],
    },
    trainlineUser: {
      card: trainlineUserCard,
      detail: [trainlineUser1, trainlineUser2, trainlineUser3],
    },
    uiLibrary: {
      card: uiLibraryCard,
      detail: [uiLibrary2, uiLibrary1, uiLibrary3],
    },
    jrProject: {
      card: jrProjectCard,
      detail: [jrproject1, jrproject2, jrproject3],
    },
    svenson: { card: svensonCard, detail: [svenson1, svenson2, svenson3] },
    svensonUser: {
      card: svensonUserCard,
      detail: [svensonUser1, svensonUser2, svensonUser3],
    },
    kammeko: { card: kammekoCard, detail: [kammeko1, kammeko2, kammeko3] },
    octacle: { card: octacleCard, detail: [octacle2, octacle3, octacle4] },
    nursery: { card: nurseryCard, detail: [nursery1, nursery2, nursery3] },
    budgetCalculator: {
      card: budgetCalcCard,
      detail: [budget3, budget2, budget4],
    },
    linkzap: { card: linkzapCard, detail: [linkzap2, linkzap3, linkzap4] },
    reva: { card: revaCard, detail: [reva2, reva3, reva4] },
  },
  personal: {
    spotify: { card: spotifyCard, detail: [sp1, sp2, sp3] },
    disney: { card: disneyCard, detail: [dc1, dc2, dc3] },
    crud: { card: crudCard, detail: [crud1, crud2, crud3] },
    reduxFilm: { card: reduxFilmCard, detail: [rf1, rf2, rf3] },
    tesla: { card: teslaCard, detail: [tc1, tc2, tc3] },
    zoom: { card: zoomCard, detail: [zc1, zc2, zc3] },
    whatsapp: { card: whatsappCard, detail: [wa1, wa2, wa3] },
    movie: { card: movieCard, detail: [ml1, ml2, ml3] },
    artistible: { card: artCard, detail: [ar1, ar2, ar3] },
    travel: { card: travelCard, detail: [ta1, ta2, ta3] },
    doggy: { card: doggyCard, detail: [dt1, dt2, dt3] },
    lottery: { card: lotteryCard, detail: [lottery2, lottery3, lottery1] },
    streaky: { card: streakyCard, detail: [streaky1, streaky2, streaky3] },
    nsuns: { card: nsunsCard, detail: [nsuns1, nsuns2, nsuns3] },
  },
  mini: {
    comingSoon,
    rps,
    theme,
    counter,
    grocery,
    blackjack,
    calculator,
    snake,
    notes,
    quiz,
    task,
    weather,
    tinyMe: tm1,
  },
};

// Export certificate images
export { playwrightCertificate };
